// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OfflineIndicator_wrapper__KlnYy","content":"OfflineIndicator_content__2fTt9"};